// extracted by css-extract-rspack-plugin
export default {"treeTable":"treeTable-l5CAJY","leftMenu":"leftMenu-Nsxfyx","rightTable":"rightTable-tTEAkl","rightTableTop":"rightTableTop-zOczcy"};